import React, { useState, useEffect, useContext } from 'react';
import { Button, Modal, Nav } from 'react-bootstrap';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useIntercom } from 'react-use-intercom';

import './index.scss';
import {
  infoMsg,
  successMsg,
  errorMsg,
  USERSNAP_API_KEY as apiKey
} from '../../config';
import { MSG } from '../../msg-const';
import WalletSlide from '../WalletSlide/WalletSlide';
import CartSlide from '../CartSlide';
import Notification from '../Notifications/Notification';
import ManagerStarLoginInfo from '../CreatorHub/ManagerStarLoginInfo';
import MainContext from '../../contexts/MainContext';
import Dropdowns from './DropDown';
import MobileMenu from './MobileMenu';
import SearchInput from './SearchInput';
import EnterBrandClubDropdown from './EnterBrandClubDropdown';
// import InstallApp from './InstallApp';
import utils from '../../utils';

import DefaultUserIcon from '../../img/svg/User/User.svg';
import { ReactComponent as Logo } from '../../img/svg/Logos/WhiteLogo.svg';
import { ReactComponent as StakeHubLogo } from '../../img/svg/Logos/StakeHubLogo.svg';
import { ReactComponent as CreatorHubLogo } from '../../img/svg/Logos/CreatorHubLogo.svg';
import { ReactComponent as CloseIcon } from '../../img/svg/Circle/crossIcon.svg';
import { ReactComponent as RealWorldFunding } from '../../img/svg/Logos/real-world-funding.svg';

const routes = ['/', '/AboutUs', '/ForCreators', '/ForFans', '/ContactUs'];

function NewHeader(props) {
  const history = useHistory();
  const { pathname } = useLocation();
  const walletId = props.prop.account;
  const context = useContext(MainContext);
  const confirmAgentReferral = props.prop.confirmAgentReferral || '';
  const [colorChange, setColorChange] = useState(true);
  const isCreatorHubRoute = window.location.href.includes('/CreatorHub');
  const [creatorhub, setCreatorhub] = useState(isCreatorHubRoute);
  const [redirecting, setRedirecting] = useState(false);
  const [agentData, setAgentData] = useState({});
  const [confirmModal, setConfirmModal] = useState(false);
  const { boot, update } = useIntercom();
  const changeNavbarColor = () => setColorChange(window.scrollY < 80);

  useEffect(() => {
    boot({ name: 'Guest', createdAt: Math.floor(Date.now() / 1000) });
    window.addEventListener('scroll', changeNavbarColor);
    return () => {
      window.removeEventListener('scroll', changeNavbarColor);
    };
  }, []);

  useEffect(() => {
    getAgentData();
  }, [confirmAgentReferral, walletId]);

  useEffect(() => {
    if (
      walletId &&
      props.prop.nickname &&
      props.prop.email &&
      props.prop.userHash
    ) {
      update({
        name: props.prop.nickname,
        email: props.prop.email,
        userId: walletId || 'default',
        createdAt: Math.floor(Date.now() / 1000),
        userHash: props.prop.userHash
      });
    }
  }, [walletId, props.prop.nickname, props.prop.email, props.prop.userHash]);

  useEffect(() => {
    if (!walletId) return;
    let usersnapApi = null;
    window.onUsersnapCXLoad = function (api) {
      api.init({
        user: {
          userId: walletId,
          email: props.prop.email || '',
          nickname: props.prop.nickname || ''
        }
      });
      usersnapApi = api;
    };
    const script = document.createElement('script');
    script.defer = 1;
    script.src = `https://widget.usersnap.com/global/load/${apiKey}?onload=onUsersnapCXLoad`;
    document.head.appendChild(script);

    return () => {
      if (usersnapApi) {
        usersnapApi.destroy();
      }
      script.remove();
    };
  }, [walletId]);

  const getAgentData = async () => {
    if (!walletId || confirmAgentReferral !== 'awaitingApproval') return;
    const data = await props.prop.apiUtility.getAgentsInfoForCreator(
      props.prop.account
    );
    if (data.status === 200 && data.data?.length) {
      data.data.forEach((agentData) => {
        if (agentData?.starConfirmation === 'awaitingApproval')
          return setAgentData(agentData);
      });
    }
  };

  const confirmAgentHandler = async (action) => {
    const ans = { walletId, agentWalletId: agentData.agentWalletId, action };
    const res = await props.prop.apiUtility.agentConfirmationAnswer(ans);
    if (res.status === 200) {
      successMsg('Answer submitted successfully');
      props.updateUserState(walletId);
    } else errorMsg(MSG['SOMETHING_WRONG']);
    setConfirmModal(false);
  };

  const onCheckPage = async () => {
    if (confirmAgentReferral === 'awaitingApproval') {
      if (!props.prop.hasCreatorAccess) history.push('/ConfirmAgentInvitation');
      else if (props.prop.hasCreatorAccess) setConfirmModal(true);
    } else {
      if (props.prop.hasCreatorAccess) {
        if (window.location.href.includes('CreatorHub')) {
          history.replace('/CreatorHub');
        } else history.push('/CreatorHub');
      } else {
        setRedirecting(true);
        if (props.prop.isRegistered) {
          if (!walletId) {
            props.connect();
            return errorMsg(MSG.PLEASE_SIGN_IN);
          }
          infoMsg(MSG.CLICK_FOR_CREATOR_ACCESS);
          history.replace('/ForCreators');
        } else {
          errorMsg(walletId ? MSG['REGISTER'] : MSG['PLEASE_SELECT_WALLET']);
          props.connect();
        }
        setCreatorhub(false);
        setTimeout(() => setRedirecting(false), 800);
      }
    }
  };

  const onStakehubClick = async () => {
    if (walletId) {
      if (!props.prop.isRegistered) {
        props.connect();
        return errorMsg(MSG['REGISTER']);
      }
      if (window.location.href.includes('StakeHub')) {
        history.replace('/StakeHub');
      } else history.push('/StakeHub');
    } else {
      props.connect();
      errorMsg(
        MSG[props.prop.isRegistered ? 'PLEASE_SIGN_IN' : 'PLEASE_SELECT_WALLET']
      );
    }
  };

  return (
    <div
      className={`new-header-wrapper ${
        colorChange && routes.includes(pathname) ? 'low-opacity' : ''
      }`}
    >
      <div className="svg-logo-wrapper">
        <Link
          to="/"
          onClick={() => {
            context.setWalletSlide(true);
            context.setCartSlide(true);
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
          }}
        >
          <RealWorldFunding />
        </Link>
      </div>
      {!walletId && <SearchInput />}
      <div className="brandclub-options">
        <EnterBrandClubDropdown walletId={walletId} />
      </div>
      <div className="d-flex gap-2 align-items-center gap-1 ms-auto">
        {/* <InstallApp /> */}
        <div className="dropdown-section">
          {!props.prop.isRegistered && (
            <>
              <Link to="/ForCreators" className="creator-span">
                For Brands
              </Link>
              <Link to="/ForFans" className="fan-span">
                For Backers
              </Link>
            </>
          )}
          <Dropdowns />
          {!props.prop.isRegistered && (
            <div className="connect-wallet-button">
              <Button onClick={() => props.connect()}>Register | Login</Button>
            </div>
          )}
          {props.prop.isRegistered && (
            <>
              <Nav.Link
                eventKey="creatorhub"
                onMouseLeave={() => setCreatorhub(isCreatorHubRoute)}
              >
                <div className="d-flex align-items-center toggle-button">
                  {creatorhub ? (
                    <>
                      <div onMouseEnter={() => setCreatorhub(false)}>
                        <StakeHubLogo />
                      </div>
                      <div onClick={onCheckPage} className="icon-items">
                        <CreatorHubLogo />
                        <span className="creator-span"> BrandHub</span>
                      </div>
                    </>
                  ) : (
                    <>
                      <div onClick={onStakehubClick} className="icon-items">
                        <StakeHubLogo />
                        <span className="fan-span"> StakeHub</span>
                      </div>
                      <div
                        onMouseEnter={() => !redirecting && setCreatorhub(true)}
                      >
                        <CreatorHubLogo className="right-logo" />
                      </div>
                    </>
                  )}
                </div>
              </Nav.Link>
              <div
                className="wallet-account-wrapper"
                onClick={() => {
                  navigator.clipboard.writeText(walletId);
                  successMsg(MSG['COPY_TO_CLIPBOARD']);
                }}
              >
                <span className="fan-span">
                  {utils.getShortAccountId(walletId)}
                </span>
              </div>
            </>
          )}
          <Modal
            className="agentConfirmationModal"
            show={confirmModal}
            centered
            onHide={() => setConfirmModal(false)}
          >
            <Modal.Header>
              <div className="agentConfirmationModal-title">
                Agent Referral Confirmation
              </div>
              <CloseIcon
                className="cursor-pointer"
                onClick={() => setConfirmModal(false)}
              />
            </Modal.Header>
            <Modal.Body>
              <div className="head mb-4">
                Are you invited by the following agent?
              </div>
              <div className="body">
                <div className="mb-2">
                  <img
                    className="agent-icon"
                    src={agentData.profilePicture || DefaultUserIcon}
                    alt="agent-icon"
                  />
                </div>
                <div className="mb-2">
                  <span className="text-gray">Full Name: </span>
                  {agentData.firstName || 'Not Available'} {agentData.lastName}
                </div>
                <div className="mb-2">
                  <span className="text-gray">Nickname: </span>
                  {agentData.nickname || 'Not Available'}
                </div>
                <div className="mb-2">
                  <span className="text-gray">Email: </span>
                  {agentData.email || 'Not Available'}
                </div>
                <div className="mb-2" style={{ wordWrap: 'break-word' }}>
                  <span className="text-gray">Wallet Id: </span>
                  {agentData.agentWalletId || 'Not Available'}
                </div>
                <p className="mb-0 text-gray">
                  NOTE: If you reject your access to BrandHub will be revoked,
                  unless admin or agent provide you with access again.
                </p>
                <div className="buttons">
                  <div
                    className="text-blue text-decoration-underline"
                    onClick={() => confirmAgentHandler('approved')}
                  >
                    Confirm
                  </div>
                  <div
                    className="text-pink text-decoration-underline"
                    onClick={() => confirmAgentHandler('rejected')}
                  >
                    Reject
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
          <ManagerStarLoginInfo
            starData={props.prop.agent_manager_profile}
            updateStarData={props.updateStarData}
          />
        </div>
        {props.prop.isRegistered && (
          <div className="d-flex align-items-center gap-2">
            <div className="brandclub-options-mobile">
              <EnterBrandClubDropdown walletId={walletId} />
            </div>
            <Notification walletId={walletId} />
            <WalletSlide
              callback={(event) => props.callback(event)}
              disconnect={() => props.disconnect()}
              picture={props.prop.profilePicture}
              account={walletId}
            />
            <CartSlide
              prop={props.prop}
              callback={(event) => props.callback(event)}
            />
          </div>
        )}
        {!props.prop.isRegistered && (
          <div className="connect-wallet-button mobile-btn">
            <Button onClick={() => props.connect()}>Register | Login</Button>
          </div>
        )}
        <MobileMenu
          walletId={walletId}
          connect={() => props.connect()}
          onCheckPage={() => onCheckPage()}
          onStakehubClick={() => onStakehubClick()}
          redirecting={redirecting}
          isRegistered={props.prop.isRegistered}
          hasCreatorAccess={props.prop.hasCreatorAccess}
        />
      </div>
    </div>
  );
}

export default NewHeader;
